import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { DropDownItem, IntDropDownItem, SimpleResponse } from '../../../models/generic-response.model';
import { Membership, MemContactListDropDown, MemInsuranceDeductible, REFMem_GetAllResponse, REF_MemProtectionPlan, REF_MemProtectionStatus } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

@Component({
    selector: 'app-mem-insurance-deductible',
    templateUrl: './mem-insurance-deductible.component.html',
    styleUrls: ['./mem-insurance-deductible.component.css']
})
/** mem-insurance-deductible component*/
export class MemInsuranceDeductibleComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MemInsuranceDeductible>;
    displayedColumns: string[] = ['protectionPlanID', 'protectionStartDate', 'protectionDeductibleAmount', 'lostEquipmentCreditTotal', 'protectionEndDate', 'protectionStatusID'];
    encryptedUser: string = ''
    insuranceDeductibleForm: FormGroup;
    user: BCMCLPUser;
    teamSub: Subscription;
    curTeam: TeamCodes = <TeamCodes>{};
    showSpinner: boolean;
    clubConfig: CMClub;
    sites: CMSite[];
    selectedSiteIDs = [];
    memInsuranceDeductible: MemInsuranceDeductible = <MemInsuranceDeductible>{};
    ref_MemProtectionPlan_List: REF_MemProtectionPlan[];
    ref_MemProtectionStatus_List: REF_MemProtectionStatus[];
    insuranceDeductibleID: number = 0;
    memberShip: Membership;
    memContact_dd: MemContactListDropDown[];
    contactId: number;
    private destroy$ = new Subject<void>();
    /** mem-insurance-deductible ctor */
    constructor(private localService: LocalService,
        private membershipService: MembershipService,
        public _localService: LocalService,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _teamOfficeService: TeamOfficeService,
        private datePipe: DatePipe,
        private fb: FormBuilder,
        private clubService: CMClubService,
        private route: ActivatedRoute
    ) {
        this.localService.setIsContract(false);
        this.localService.setShowMenu(true);
        this.localService.setIsMembership(true);
        this.localService.setRouteName("mem-insurance");
    }

    ngOnInit() {
         this.insuranceDeductibleForm = this.prepareInsuranceDeductibleForm()

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    prepareInsuranceDeductibleForm() {
        return this.fb.group({
            protectionPlanID: [0],
            protectionStartDate: [''],
            protectionDeductibleAmount: ['0'],
            lostEquipmentCreditTotal: ['0'],
            protectionEndDate: [''],
            protectionStatusID: [0],
            contactId: [0]
        })
    }

    ngAfterViewInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.insuranceDeductibleID = this.route.snapshot.queryParams.insuranceDeductibleID ? this.route.snapshot.queryParams.insuranceDeductibleID : 0;
                    this.contactId = this.route.snapshot.queryParams.contactId ? +this.route.snapshot.queryParams.contactId : 0;
                    if (this.insuranceDeductibleID > 0 || this.contactId > 0) {
                        this.memInsuranceDeductible_Get();
                        this.membership_GetByContactID(this.contactId)
                    }
                    this.loadData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_MemProtectionPlan_List = this.localService.refMem_GetAllResponse.ref_MemProtectionPlan_List;
                    this.ref_MemProtectionStatus_List = this.localService.refMem_GetAllResponse.ref_MemProtectionStatus_List;
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.memContactDDget();
                    this.ref_MemProtectionPlan_List = this.localService.refMem_GetAllResponse.ref_MemProtectionPlan_List;
                    this.ref_MemProtectionStatus_List = this.localService.refMem_GetAllResponse.ref_MemProtectionStatus_List;
                }
            }
        })
    }


    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            this.showSpinner = true
            await this.clubService.CMClub_Get(this.encryptedUser, this.user?.cLPCompanyID, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }
                    this.showSpinner = false
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.sites = response?.sites;
                        this.sites.unshift({
                            siteID: 0,
                            clubID: 0,
                            class1Code: 0,
                            clpcompanyID: 0,
                            siteName: "--Select--",
                            teamCode: 0,
                            address: "",
                            city: "",
                            state: "",
                            country: "",
                            zip: "",
                            taxRate: 0,
                            scheduleSiteVisitURL: "",
                            scheduleOpenHouseURL: "",
                            vesselsURL: "",
                            kioskURL: "",
                            lnkCustom1URL: "",
                            lnkCustom2URL: "",
                            lnkCustom3URL: "",
                            lnkCustom4URL: "",
                            lnkCustom5URL: "",
                            mktCustomText1: "",
                            mktCustomText2: "",
                            mktCustomText3: "",
                            mktCustomText4: "",
                            mktCustomText5: "",
                            mktMultiText1: "",
                            mktMultiText2: "",
                            mktMultiText3: "",
                            mktMultiText4: "",
                            mktMultiText5: "",
                            engDashCustomMMT1D1: "",
                            engDashCustomMMT1D2: "",
                            engDashCustomMMT1D3: "",
                            engDashCustomMMT1D4: "",
                            engDashCustomMMT1D5: "",
                            engDashCustomMMT1D6: "",
                            engDashCustomMMT1D7: "",
                            engDashCustomMMT1D8: "",
                            engDashCustomMMT1D9: "",
                            engDashCustomMMT1D10: "",
                            dtCreated: "",
                            dtModified: "",
                            newLead: 0,
                            newMember: 0,
                            contractSent: 0,
                            contractOpen: 0,
                            waitingCountersign: 0,
                            memberAdded: 0,
                            contractUpgraded: 0,
                            contractRenewed: 0,
                            memberTerminated: 0,
                            contractExpiration: 0,
                            contactUpdate: 0,
                            referralRequest: 0,
                            teamCodeDisplay: "",
                            class1Display: "",
                            phLocation: "",
                            custom1: '',
                            custom2: '',
                            custom3: '',
                            contractCounts: 0
                        })
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }



    async memInsuranceDeductible_Create() {
        let memInsuranceDeductible: MemInsuranceDeductible = <MemInsuranceDeductible>{};
        memInsuranceDeductible.clpCompanyID = this.user?.cLPCompanyID;
        memInsuranceDeductible.clpUserID = this.user?.cLPUserID;
        memInsuranceDeductible.contactID = +this.insuranceDeductibleForm.controls.contactId.value;
        memInsuranceDeductible.insuranceDeductibleID = 0;
        memInsuranceDeductible.protectionDeductibleAmount = +this.insuranceDeductibleForm.controls.protectionDeductibleAmount.value;
        memInsuranceDeductible.lostEquipmentCreditTotal = +this.insuranceDeductibleForm.controls.lostEquipmentCreditTotal.value;
        memInsuranceDeductible.protectionPlanID = +this.insuranceDeductibleForm.controls.protectionPlanID.value;
        memInsuranceDeductible.protectionStatusID = +this.insuranceDeductibleForm.controls.protectionStatusID.value;
        memInsuranceDeductible.protectionStartDate = this.datePipe.transform(this.insuranceDeductibleForm.controls.protectionStartDate.value, 'MM/dd/yyyy');
        memInsuranceDeductible.protectionEndDate = this.datePipe.transform(this.insuranceDeductibleForm.controls.protectionEndDate.value, 'MM/dd/yyyy');
        memInsuranceDeductible.membershipIID = +this.memberShip.incrementalID;
        await this.membershipService.memInsuranceDeductible_Create(this.encryptedUser, memInsuranceDeductible)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.insuranceDeductibleID = response.messageInt;
                    if (response?.messageBool) {
                        this._router.navigate(['/mem-insurance'], { queryParams: { insuranceDeductibleID: this.insuranceDeductibleID } });
                        Swal.fire({ icon: "success", title: "", html: 'Successfully Created!' });
                        return;
                    }
                    else {

                    }
                }
                else {
                    Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                    return;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async memInsuranceDeductible_Update() {
        let memInsuranceDeductible: MemInsuranceDeductible = <MemInsuranceDeductible>{};
        memInsuranceDeductible.insuranceDeductibleID = this.insuranceDeductibleID > 0 ? this.insuranceDeductibleID : this.memInsuranceDeductible?.insuranceDeductibleID;
        memInsuranceDeductible.clpCompanyID = this.user?.cLPCompanyID;
        memInsuranceDeductible.clpUserID = this.user?.cLPUserID;
        memInsuranceDeductible.contactID = +this.insuranceDeductibleForm.controls.contactId.value;
        memInsuranceDeductible.membershipIID = +this.memberShip.incrementalID;
        memInsuranceDeductible.protectionDeductibleAmount = +this.insuranceDeductibleForm.controls.protectionDeductibleAmount.value;
        memInsuranceDeductible.lostEquipmentCreditTotal = +this.insuranceDeductibleForm.controls.lostEquipmentCreditTotal.value;
        memInsuranceDeductible.protectionPlanID = +this.insuranceDeductibleForm.controls.protectionPlanID.value;
        memInsuranceDeductible.protectionStatusID = +this.insuranceDeductibleForm.controls.protectionStatusID.value;
        memInsuranceDeductible.protectionStartDate = this.datePipe.transform(this.insuranceDeductibleForm.controls.protectionStartDate.value, 'MM/dd/yyyy');
        memInsuranceDeductible.protectionEndDate = this.datePipe.transform(this.insuranceDeductibleForm.controls.protectionEndDate.value, 'MM/dd/yyyy');
        await this.membershipService.memInsuranceDeductible_Update(this.encryptedUser, memInsuranceDeductible)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    Swal.fire({ icon: "success", title: "", html: 'Successfully update!.' });
                    return;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
                Swal.fire({ icon: "error", title: "", html: 'Some error occurred, Try again.' });
                return;
            });
    }

    async memInsuranceDeductible_Delete() {
        Swal.fire({
            title: '',
            text: "Are you sure, You wants to delete?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this.membershipService.memInsuranceDeductible_Delete(this.encryptedUser, this.insuranceDeductibleID)
                    .then(async (result: SimpleResponse) => {
                        if (result) {
                            let response = UtilityService.clone(result);
                            if (response?.messageBool) {
                                this._router.navigate(['/mem-insurance-list'])
                            }
                            else {

                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this._globalService.error("contact-task.getLoadUsers", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });


    }

    async memInsuranceDeductible_Get() {
        await this.membershipService.memInsuranceDeductible_Get(this.encryptedUser, this.insuranceDeductibleID, this.contactId)
            .then(async (result: MemInsuranceDeductible) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memInsuranceDeductible = <MemInsuranceDeductible>{};
                    this.memInsuranceDeductible = response;
                    if (response.insuranceDeductibleID > 0) {
                        this.prepareMemInsurancePatch();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareMemInsurancePatch() {
        this.insuranceDeductibleForm.patchValue({
            protectionPlanID: this.memInsuranceDeductible.protectionPlanID,
            protectionStartDate: this.memInsuranceDeductible.protectionStartDate,
            protectionDeductibleAmount: this.memInsuranceDeductible.protectionDeductibleAmount,
            lostEquipmentCreditTotal: this.memInsuranceDeductible.lostEquipmentCreditTotal,
            protectionEndDate: this.memInsuranceDeductible.protectionEndDate,
            protectionStatusID: this.memInsuranceDeductible.protectionStatusID
        });
    }


    async memContactDDget() {
        await this.membershipService.memContact_CMMember_GetList_DD(this.encryptedUser, this.user?.cLPCompanyID, this.user?.cLPUserID, this.clubConfig?.clubId)
            .then(async (result: MemContactListDropDown[]) => {
                if (result) {
                    this.memContact_dd = UtilityService.clone(result);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.memContactDDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }


    async onChangeMemContact() {
        await this.membership_GetByContactID(+this.insuranceDeductibleForm.controls.contactId.value);
    }

    async membership_GetByContactID(contactId) {
        await this.membershipService.membership_GetByContactID(this.encryptedUser, contactId)
            .then(async (result: Membership) => {
                if (result) {
                    this.memberShip = <Membership>{};
                    this.memberShip = UtilityService.clone(result);
                    if (isNullOrUndefined(this.memberShip)) {
                        Swal.fire({ icon: "error", title: "", html: 'The Contact is Not Subcribe!' });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-pause.membership_GetByContactID_DDget", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

}
